(function($) {

	var $ajaxNewsletter = $('#ajax-newsletter');

	if ($ajaxNewsletter.length) {

		$ajaxNewsletter.on('submit', function(e) {
			e.preventDefault();

			var $form = $(this);

			if (!$form.animatoIsValid()) return false;

			$.ajax({
				url: $form.attr('action'),
				method: 'POST',
				data: $form.serialize() + '&disable-return=true',
			}).done(function( msg ) {
				$form.fadeOut(300, function() {
					$('<div class="mb-2" style="display: none">' + msg + '</div>')
						.insertAfter($form)
						.fadeIn();
				});
			}).fail(function( jqXHR, textStatus ) {
				console.log('Request failed: ' + textStatus);
			});
		});

	}

})(jQuery);
